import { useState } from "react";
import { FaLinkedin } from "react-icons/fa6";
import { LEADERSHIP_TEAM, type LeadershipMember } from "../data/leadership";
import ScrollReveal from "./ScrollReveal";
import LeadershipBioModal from "./LeadershipBioModal";

/** Shows a "coming soon" placeholder until LEADERSHIP_TEAM has real entries — no fabricated people. */
export default function LeadershipGrid() {
  const [activeMember, setActiveMember] = useState<LeadershipMember | null>(null);

  if (LEADERSHIP_TEAM.length === 0) {
    return (
      <div className="mx-auto max-w-md rounded-2xl bg-white/5 p-8 text-center ring-1 ring-white/10">
        <p className="text-sm text-foam-100/60">Our leadership team profiles are coming soon — check back shortly.</p>
      </div>
    );
  }

  return (
    <>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {LEADERSHIP_TEAM.map((member, i) => (
          <ScrollReveal key={member.id} delay={i * 0.08}>
            <div className="rounded-2xl bg-white/5 p-6 ring-1 ring-white/10 transition-colors hover:bg-white/10">
              <img
                src={member.photoUrl}
                alt=""
                title={member.photoCredit}
                loading="lazy"
                width={80}
                height={80}
                className="h-20 w-20 rounded-full object-cover"
              />
              <h3 className="mt-4 font-display font-semibold">{member.name}</h3>
              <p className="text-sm text-teal-300/80">{member.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-foam-100/70">{member.bio}</p>
              <div className="mt-4 flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => setActiveMember(member)}
                  className="py-1 text-sm font-semibold text-teal-300 hover:text-teal-200"
                >
                  Read full bio
                </button>
                <a
                  href={member.linkedinUrl}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`${member.name} on LinkedIn`}
                  className="ml-auto flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-teal-300 hover:bg-white/20"
                >
                  <FaLinkedin className="h-4 w-4" />
                </a>
              </div>
            </div>
          </ScrollReveal>
        ))}
      </div>
      <LeadershipBioModal member={activeMember} onClose={() => setActiveMember(null)} />
    </>
  );
}
